import { mapFields } from "@/mocks/chigua";

export default function KnowledgeMap() {
  return (
    <section id="map" className="w-full scroll-mt-20 py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 max-w-2xl">
          <p className="flex items-center gap-2 text-sm font-medium text-primary-600 mb-2">
            <span className="inline-block h-px w-8 bg-primary-400"></span>KNOWLEDGE MAP
          </p>
          <h2 className="font-display text-2xl md:text-4xl font-bold text-foreground-950">
            知识图谱 · <span className="text-primary-600">多维度导航</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            人物、事件、领域、时间四个圈层交叉索引，像一张动态情报网。同一块瓜，换一种打开方式就有新发现。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {mapFields.map((f) => (
            <div
              key={f.name}
              className="rounded-xl border border-background-200 bg-background-50 p-6"
            >
              <div className="flex items-start gap-4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700 text-2xl">
                  <i className={f.icon}></i>
                </span>
                <div className="flex-1">
                  <div className="flex items-baseline justify-between">
                    <h3 className="text-lg font-semibold text-foreground-950">{f.name}</h3>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{f.desc}</span>
                  </div>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {f.children.map((ch) => (
                      <a
                        key={ch}
                        href="#trending"
                        className="whitespace-nowrap rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1 text-xs text-secondary-800 hover:bg-secondary-100 transition-colors"
                      >
                        {ch}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-6 text-center text-sm text-foreground-500">
          四维交叉索引，帮你绕过信息噪音，直达真正想追的那一块。
        </p>
      </div>
    </section>
  );
}